




























































































































































import { defineComponent, ref, useRouter, useMeta } from '@nuxtjs/composition-api';
import ApplicationBar from '@/components/layout/applicationbar.vue';
import { PREFECTURE } from '@/configs';
import { IInquiryForm, VForm } from '@/types';
import { Save } from '@/compositions/base-save';

export default defineComponent({
  name: 'PageInquiry',
  components: { ApplicationBar },
  layout: 'register',
  setup() {
    const router = useRouter();
    const { meta } = useMeta();
    const {
      setSaveConfig,
      saveData,
      error,
      saveError,
      isRequired,
      isEmail,
      valid
    } = Save();

    const form = ref<IInquiryForm>({
      company_name: '',
      name: '',
      pref_name: '',
      email: '',
      confirm: '',
      tel: '',
      body: ''
    });

    meta.value = [
      {
        hid: 'robots',
        name: 'robots',
        content: 'noindex'
      }
    ];

    const formRef = ref<null | VForm>(null);

    // 入力チェック後登録処理実行
    const validate = (): void => {
      if (formRef.value?.validate()) {
        setSaveConfig('/api/v1/inquiry/send', {
          successWithMessage: true,
          useResponseMessage: true,
          doToast: false
        });

        // _token: "967c3932557f0379730470f82e0099a4a057adbfa867d5c83a7f006d4b547cbb21ab0e95be4ec5312920453bed6aa012a5878b244a64cc4a135b0bf3fa70e39d"

        saveData({ data: form.value }).then(() => {
          if (!saveError.value) {
            router.push('/inquiry/completed');
          }
        });
      }
    };

    return {
      PREFECTURE,
      form,
      saveError,
      error,
      valid,
      formRef,
      validate,
      isRequired,
      isEmail
    };
  },
  head: {}
});
